import GetPostResponse from 'Global/Functions/GetPostResponse/GetPostResponse';
import { Post } from 'Xhr/Xhr';
import SwalAlert from '../../../../../../SwalAlert/SwalAlert';
import { env } from 'env';

export const UpdateWordList = (data, setForceRender) => {
  Post(
    'POST',
    `${process.env.REACT_APP_API_URL_API_UPDATE_LOCALIZATION_LANGUAGE}`,
    true,
    {
      list: [...data],
    }
  ).then((response) => {
    if (response.data.resCode === 1) {
      SwalAlert('success', response.data.resMessage, false);
      setForceRender((prev) => !prev);
    } else {
      SwalAlert('warning', response.data.resMessage, false);
      setForceRender((prev) => !prev);
    }
  });
};
